import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

function ThreatMap({ activities }) {
  const getHourlyRisk = () => {
    const hourlyData = Array(24)
      .fill(0)
      .map((_, i) => ({
        hour: i,
        risk: 0,
        count: 0,
        label: `${i.toString().padStart(2, '0')}:00`,
      }));

    activities.forEach((activity) => {
      const hour = new Date(activity.timestamp).getHours();
      hourlyData[hour].risk += activity.risk_score || 0;
      hourlyData[hour].count += 1;
    });

    const currentHour = new Date().getHours();
    const last12Hours = [];
    for (let i = 11; i >= 0; i--) {
      const hour = (currentHour - i + 24) % 24;
      last12Hours.push(hourlyData[hour]);
    }
    return last12Hours;
  };

  const data = getHourlyRisk();
  const maxRisk = Math.max(...data.map((d) => d.risk), 1);

  const getBarColor = (risk) => {
    if (risk >= maxRisk * 0.7) return 'hsl(var(--destructive))';
    if (risk >= maxRisk * 0.4) return 'hsl(var(--warning))';
    if (risk >= maxRisk * 0.2) return 'hsl(var(--primary))';
    return 'hsl(var(--success))';
  };

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Threat Map (Last 12 Hours)</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
            <XAxis dataKey="label" tick={{ fontSize: 10, fill: 'hsl(var(--muted-foreground))' }} />
            <YAxis tick={{ fill: 'hsl(var(--muted-foreground))' }} />
            <Tooltip
              contentStyle={{
                backgroundColor: 'hsl(var(--card))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '0.5rem',
                color: 'hsl(var(--foreground))',
              }}
              formatter={(value, name, props) => [`Risk: ${value}`, `Events: ${props.payload.count}`]}
            />
            <Bar dataKey="risk" radius={[8, 8, 0, 0]}>
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={getBarColor(entry.risk)} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}

export default ThreatMap;
